import { dataHooks as wixDataHooks } from '@wix/data-hooks'

export const dataHooks = wixDataHooks<{
  mainButton: {}
  secondButton: {}
}>('headless-fallback')
